<template>
  <div>
    <el-card shadow="never">
      <p class="justify-text">{{testimonial.Testimonial}}</p>
      <el-button
        :type="userHasLiked? 'primary': ''"
        :plain="!userHasLiked"
        @click="like"
        round
        size="mini"
      >
        <font-awesome-icon icon="thumbs-up" class="thumbsUp-icon"/>
        {{testimonial.Rating}} likes
      </el-button>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['testimonial'],
  computed: {
    ...mapGetters(['user']),
    userHasLiked() {
      return (
        this.user &&
        this.user.RecipeTestimonialRatings.some(
          r => r.RecipeTestimonialId === this.testimonial.Id
        )
      )
    }
  },
  methods: {
    like() {
      this.$emit('likeTestimonial', this.testimonial)
    }
  }
}
</script>

<style scoped>
.thumbsUp-icon {
  margin-right: 5px;
}
.justify-text {
  text-align: justify;
}
</style>
